export default __webpack_public_path__ + "static/media/faqVector.d29a4fe3.png";